var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor"}},[_c('div',{ref:"editorElem",staticStyle:{"text-align":"left"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }